import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Developer",
          
          // "NLP Enthusiast",
          // "MERN/MEVN Stack Developer",
          // "Open Source Contributor",
          "Problem Solver",
          "Djnago Developer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
